import { createRouter, createWebHistory } from 'vue-router';
import WelcomeView from '../views/Welcome.vue';
import DeviceAudioView from '../views/DeviceAudio.vue';
import DeviceDMCView from '../views/DeviceDMC.vue';
import DeviceNetworkView from '../views/DeviceNetwork.vue';
import DeviceWirelessView from '../views/DeviceWireless.vue';
import SetupPowerView from '../views/SetupPower.vue';
import SetupPairView from '../views/SetupPair.vue';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'welcome',
            component: WelcomeView,
        },
        {
            path: '/device',
            name: 'device',
            children: [
                {
                    path: 'audio',
                    name: 'audio',
                    component: DeviceAudioView,
                },
                {
                    path: 'dmc',
                    name: 'dmc',
                    component: DeviceDMCView
                },
                {
                    path: 'network',
                    network: 'network',
                    component: DeviceNetworkView,
                },
                {
                    path: 'wireless',
                    network: 'wireless',
                    component: DeviceWirelessView,
                },
            ],
        },
        {
            path: '/setup',
            name: 'setup',
            children: [
                {
                    path: '1',
                    name: 'setupPower',
                    component: SetupPowerView,
                },
                {
                    path: '2',
                    name: 'setupPair',
                    component: SetupPairView,
                },
                {
                    path: '3',
                    name: 'setupNetwork',
                    component: DeviceNetworkView,
                    meta: { mode: 'setup' },
                },
                {
                    path: '4',
                    name: 'setupWifi',
                    component: DeviceWirelessView,
                    meta: { mode: 'setup' },
                },
            ],
        },
    ],
});

export default router;
